import classNames from "classnames";
import styles from "./styles.module.scss";

export const CardSeparator = ({ ...props }) => {
  return <div {...props} className={classNames(styles["card-separator"], props.className)}></div>;
};
